import component from './PhLadderSimple.vue_vue_type_script_lang.vue.js';
export { default } from './PhLadderSimple.vue_vue_type_script_lang.vue.js';
import { render } from './PhLadderSimple.vue_vue_type_template_id_05cf3b10_lang.vue.js';

component.render = render;
